import './style.css'
import ReactDOM from 'react-dom/client'
import Experience from './Experience.jsx'
import UI from './UI.jsx'
import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import { Loader } from '@react-three/drei'
import { Analytics } from "@vercel/analytics/react"
import Wobble from './Wobble.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
   <>  
   

   <Suspense fallback={[null]}> 
        <Canvas
            className="r3f"
            shadows
            dpr={[1,1]}
        >
            
                <Experience />
                <Analytics/>
            
        </Canvas>
        
        <Wobble />
        <UI />  
        </Suspense>
        
        <Loader/>



    
    </>
)


